import Login from "containers/Login";
import withPublic from "utils/withPublic";

const LoginPage = (props) => <Login type="login" {...props} />;

export default withPublic(LoginPage);
